import { createSpaceApi, type SpaceApi } from "@wakeloop/api-client";
import { createCliApiClientFoundation } from "./api-client-foundation";

export type {
  SpaceApi,
  SpaceSignalsReadQuery,
} from "@wakeloop/api-client";

export function createCliSpaceApi(baseUrl: string): SpaceApi {
  return createSpaceApi(createCliApiClientFoundation(baseUrl));
}
